
import { useNavigate } from "react-router-dom";
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEOHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Return to ParadoxEdge to explore executive coaching and leadership development."
        canonicalUrl="/404"
        noindex
      />
      <div className="min-h-screen bg-black">
        <Navigation />
        <div className="flex-1 flex items-center justify-center p-4 min-h-[calc(100vh-200px)]">
          <div className="text-center space-y-4">
            <h1 className="text-4xl md:text-6xl font-bold text-[#38FFFF]">404</h1>
            <h2 className="text-2xl md:text-3xl font-bold text-white">Page Not Found</h2>
            <p className="text-xl md:text-2xl text-white/80 mb-8">The page you're looking for doesn't exist.</p>
            <button 
              onClick={() => navigate('/', { replace: true })}
              className="px-6 py-3 text-black bg-white hover:bg-gray-200 rounded-lg transition-colors"
            >
              Return to Home
            </button>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
